import { Component, Inject } from '@angular/core';
import { BrandingService } from '../Services/BrandingService';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    styles: [`

.logo {
    margin-left: auto;
    margin-right: auto;
    display: block;
    height: 45px;
}

.confirm-panel{
    padding-top: 60px;
    margin: 0 auto;
}

.confirmation-text {
    color: #333333;
    font-family: Arial;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
}

.confirmation-description {
    color: #333333;
    font-family: Arial;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
}

.email-icon {
    height: 150px;
    width: 150px;
    margin-left: auto;
    margin-right: auto;
    display: block;
}

.right-link {
    margin-left: auto;
    text-align: right;
}

.links {
    display: flex;
    flex-direction: row;
    color: #009FDE;
    font-family: Arial;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 24px;
}

.link {
    text-decoration: none;
    color: #009FDE;
}

.box {
    width: 500px;
    height: auto;
    background-color: #FFFFFF;
    margin: 0 auto;
    padding: 24px;
    margin-top: 48px;
    min-width: 320px;
}

.policy {
    text-align: center;
    padding-top: 16px;
}

.container{
    height: 100%;
    width: 100%;
    background-color: #F4FAFC;
    display: flex;
}

.policy-link {
    color: #003952;
    font-family: Arial;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    text-decoration: none;
}

.standard-text-color {
    color: #333333;
}

.link-text-color {
    color: #009fde;
}

.ToS-text-color {
    color: #003952;
}

.sign-in-button {
    background-color: #00A698;
    color: #fff;
}

#light-mode {
    display: block;
}

#dark-mode {
    display: none;
}


.text{
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}

.small-text{
    padding-top: 8px;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

.checkthisout{
    color: red;
}

::ng-deep .en:before {
    background-image: url(/identity/content/icons/usa_flag.png) !important;
}

::ng-deep .br:before {
    background-image: url(/identity/content/icons/brazil_flag.png) !important;
}

::ng-deep .dropdown-icon {
    content: url("/identity/content/icons/dropdown-button.png");
}

.language {
    background-color: #F4FAFC !important;
}

@media (prefers-color-scheme: dark) {
    .standard-text-color {
        color: #E6E6E6;
    }

    ::ng-deep .language {
        background-color: #2A2A2A !important;
    }

    .box{
        background-color: #333333;
    }

    .ToS-text-color {
        color: #1CA8DD;
    }

    .link-text-color {
        color: #1CA8DD;
    }

    .background {
        background-color: #2A2A2A;
    }

    .sign-in-button {
        background-color: #1CA8DD;
        border: 0 !important;
    }

    ::ng-deep.dx-texteditor {
        background-color: #2A2A2A !important;
        border: 1px solid #454545 !important;
    }

    ::ng-deep .dx-field-item-label-text {
        color: #E6E6E6 !important;
    }

    ::ng-deep .dx-texteditor-input{
        color: #E6E6E6;
    }

    #light-mode {
        display: none !important;
    }

    #dark-mode {
        display: block !important;
    }
}

/* for mobile*/
@media (max-width: 768px) {
    .box{
        width: calc( 100% - 48px);
    }
}
`],
    template: `
    <div class="container background">
        <div class="confirm-panel" >
            <ng-container *ngIf="!branding.hideLogo">
                <img id="light-mode" class="logo" [src]="branding.logoUrl" alt="" />
                <img id="dark-mode" class="logo" [src]="branding.logoUrlDark" alt="" />
            </ng-container>
            <div class="box">
                <img style="margin-bottom: 30px;" class="email-icon" src="/identity/content/icons/email-sent.png" />
                <p class="confirmation-text standard-text-color text" *ngIf="newCompany">{{'Thank you!' | translate}}</p>
                <p class="confirmation-text standard-text-color text" *ngIf="newCompany">{{'We are setting up your account.' | translate}}</p>
                <p class="confirmation-text standard-text-color text" *ngIf="!(newCompany)">{{'Thank you!' | translate}} </p>
                <p class="confirmation-text standard-text-color text" *ngIf="!(newCompany)">{{'We have sent your sign up request to your company administrator.' | translate}} </p>
                <p class="confirmation-description standard-text-color small-text" *ngIf="newCompany">{{'You will receive an email with your login details at' | translate}} <span style="height: auto; word-break: break-word;font-weight: bold; " class="link-text-color"> {{email}} </span> </p>
                <p class="confirmation-description standard-text-color small-text" *ngIf="!(newCompany)">{{'Once approved, you will receive an email with your login to' | translate}} <span style="height: auto; word-break: break-word;font-weight: bold; " class="link-text-color"> {{email}} </span> </p>
                <div class="links">
                    <div *ngIf="!branding.hideRegisterReturnToSignIn">
                        <a class="link link-text-color" href="../../">{{'Sign in' | translate}}</a>
                    </div>
                    <div class="right-link">
                        <a class="link link-text-color" [href]="branding.supportUrl" target="_blank">{{'Contact support' | translate}}</a>
                    </div>
                </div>
            </div>
            <p class="policy">
                <a class="policy-link ToS-text-color" [href]="branding.privacyPolicyUrl" target="_blank">{{'Privacy Policy' | translate}}</a>
                <span class="dot" style="margin: auto 0;"> • </span>
                <a class="policy-link ToS-text-color" [href]="branding.termsOfServiceUrl" target="_blank">{{'Terms of Service' | translate}}</a>
            </p>
        </div>
    </div>
    `,
})
export class RegisterComplete {
    email = "specified email";
    newCompany = false;
    constructor(public branding: BrandingService, private translate: TranslateService, private _router: Router, private _route: ActivatedRoute, @Inject('Claims') private _claims: any) {
        this.translate.use(this._claims.UserLangCookie);
        this.email = this._route.snapshot.params['email'];
        this.newCompany = this._route.snapshot.params['newcompany'] === "true" ? true : false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Register/RegisterComplete.ts